module.exports = __webpack_public_path__ + "img/WL_cover.c481c6af.jpg";